import { render, staticRenderFns } from "./SmallBlog.vue?vue&type=template&id=f80f245e&"
import script from "./SmallBlog.vue?vue&type=script&lang=js&"
export * from "./SmallBlog.vue?vue&type=script&lang=js&"
import style0 from "./SmallBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports